<script setup lang="ts">
// Row of payment marks driven by the admin's enabled rails
// (`usePaymentMethods` → GET /cms/payment-methods). Renders nothing when no
// rail is enabled. Ported from GAMZOR (GamingForge) checkout/PaymentMarks.vue.
import { useI18n } from 'vue-i18n';
import { usePaymentMethods } from '../composables/usePaymentMethods';
import PaymentMethodMark from './PaymentMethodMark.vue';

const { t } = useI18n();
const { methods } = usePaymentMethods();
</script>

<template>
  <ul v-if="methods.length" class="flex flex-wrap items-center gap-1.5" :aria-label="t('footer.paymentMethods')">
    <li v-for="m in methods" :key="m.slug">
      <PaymentMethodMark :slug="m.slug" :name="m.name" :icon="m.icon" />
    </li>
  </ul>
</template>
